module.exports = __webpack_public_path__ + "media/images/iconPlus-69367481470daf886effa6a3e471018c.png";